import axios from 'axios';
import Pagination from '@/domain/pagination.entity';
import Response from '@/domain/response.entity';
import RuleScript from '../entity/rule-script.entity';
import RuleHistory from '../entity/rule-history.entity';
import RuleHistoryDetail from '../entity/rule-history-detail.entity';
import RuleUsage from '../entity/rule-usage.entity';
import RuleVersionDiff from '../entity/rule-version-diff.entity';

export default class RuleHistoryService {
  public static saveDraft(
    businessUnitId: string, ruleId: string, ruleScript: RuleScript,
  ): Promise<RuleHistory> {
    return axios.post(`/api/v1/business-units/${businessUnitId}/rules/${ruleId}/draft`, ruleScript)
      .then((response: any) => RuleHistory.of(response.data))
  }

  public static getHistory(
    businessUnitId: string, ruleId: string, pagination: Pagination,
    filter: { status?: string | null; createdBy?: string | null } = {},
  ): Promise<Response> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/rules/${ruleId}/history`, {
      params: {
        page: pagination.page - 1,
        size: pagination.itemsPerPage,
        sortBy: 'versionMajor|desc,versionMinor|desc',
        status: filter.status || undefined,
        createdBy: filter.createdBy || undefined,
      },
    }).then((response: any) => Response.of(response.data))
  }

  public static getHistoryVersion(
    businessUnitId: string, ruleId: string, version: string,
  ): Promise<RuleHistoryDetail> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/rules/${ruleId}/history/${version}`)
      .then((response: any) => RuleHistoryDetail.of(response.data))
  }

  public static publishVersion(
    businessUnitId: string, ruleId: string, version: string,
  ): Promise<RuleScript> {
    return axios.post(`/api/v1/business-units/${businessUnitId}/rules/${ruleId}/history/${version}/publish`)
      .then((response: any) => RuleScript.of(response.data))
  }

  public static restoreVersion(
    businessUnitId: string, ruleId: string, version: string,
  ): Promise<RuleScript> {
    return axios.post(`/api/v1/business-units/${businessUnitId}/rules/${ruleId}/history/${version}/restore`)
      .then((response: any) => RuleScript.of(response.data))
  }

  public static getUsage(businessUnitId: string, ruleId: string): Promise<RuleUsage[]> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/rules/${ruleId}/usage`)
      .then((response: any) => RuleUsage.ofList(response.data))
  }

  public static diffVersions(
    businessUnitId: string, ruleId: string, from: string, to: string,
  ): Promise<RuleVersionDiff> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/rules/${ruleId}/history/diff`, {
      params: { from, to },
    }).then((response: any) => RuleVersionDiff.of(response.data))
  }
}
